<div class="wrapper__headerComponent container my-5">
  <div class="container-example-linea-avance-govco mx-0 my-5">
    <div class="linea-avance-govco ih-linea-avance-govco m-0 p-0" id="lineaAvance3">
      <div class="mb-4">
        <div class="progress" style="width: 100% !important;">
          <progress class="progress-bar" value="15" max="100">
          </progress>
        </div>
        <div class="items-header-linea-avance-govco">
          <div class="header-linea-avance-govco active-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance1" percentage="15"
                    onClick="clickHorizontalAdvanceLine(event)"
                    aria-label="Ir a paso 1">
              <span>1</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][0] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance2"
                    percentage="17" onClick="clickHorizontalAdvanceLine(event)"
                    aria-label="Ir a paso 2">
              <span>2</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][17] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance3"
                    percentage="34" onClick="clickHorizontalAdvanceLine(event)"
                    aria-label="Ir a paso 3">
              <span>3</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][1] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance4"
                    percentage="51" onClick="clickHorizontalAdvanceLine(event)"
                    aria-label="Ir a paso 4">
              <span>4</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][18] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance5"
                    percentage="68" onClick="clickHorizontalAdvanceLine(event)"
                    aria-label="Ir a paso 5">
              <span>5</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][19] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance6"
                    percentage="85" onClick="clickHorizontalAdvanceLine(event)"
                    aria-label="Ir a paso 6">
              <span>6</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][20] }}
            </span>
          </div>
          <div class="header-linea-avance-govco">
            <button class="indicator-linea-avance-govco" type="button" data-la-target="#itemlineaAvance7"
                    percentage="100" onClick="clickHorizontalAdvanceLine(event)"
                    aria-label="Ir a paso 7">
              <span>7</span>
            </button>
            <span class="title-linea-avance-govco">
              {{ roiText['reorganizacion-ordinaria-insolvencia']['titulos'][13] }}
            </span>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance1" class="body-linea-avance-govco active-linea-avance-govco"
           data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección: Información inicial e Identificación del deudor-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][21]"
              [fields]="camposIDdeudor"
              [withSubmitButton]="false"
              (changedControl)="capturarFormIDDeudor($event)">
            </app-form>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                        (click)="guardarProceso(false)"
                        [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                    (click)="onContinueIDdeudor($event)"
                    [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance2" class="body-linea-avance-govco"
                 data-la-parent="#lineaAvance3">
      <div class="contents-linea-avance-govco">
        <div class="contents-example-linea-avance-govco">
          <!-- Sección: Agregar profesionales-->
          <!-- Revisor fiscal -->
          <app-form
            #FormComponent
            *ngIf="mostrarTipoRevisor"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_revisor']"
            [fields]="campoTipoRevisor"
            (changedControl)="capturarFormTipoRevisor($event)"
            [withSubmitButton]="false">
          </app-form>
          <!-- Revisor fiscal PN -->
          <app-form
            #FormComponent
            *ngIf="mostrarRevisorPN"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal_PN']"
            [fields]="camposRevisorPN"
            (changedControl)="capturarFormRevisorPN($event)"
            [withSubmitButton]="true"
            [sumbitButtonText]="comunText['agregar-revisor']"
            (submitAction)="guardarProfesional(false, 'revisor')"
            [filtrarTiposDocumento]="true">
          </app-form>
          <!-- Revisor fiscal PJ -->
          <app-form
            #FormComponent
            *ngIf="mostrarRevisorPJ"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal_PJ']"
            [fields]="camposRevisorPJ"
            (changedControl)="capturarFormRevisorPJ($event)"
            [withSubmitButton]="true"
            [sumbitButtonText]="comunText['agregar-revisor']"
            (submitAction)="guardarProfesional(false, 'revisor')">
          </app-form>
          <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
            {{ roiText['reorganizacion-ordinaria-insolvencia']['comun']['revisor_fiscal'] }}
          </h4>
          <div class="col-12 d-flex justify-content-end">
            <button
              type="submit"
              class="btn-govco fill-add-govco mt-3"
              (click)="habilitarTipoRevisor()"
              [disabled]="datosRevisores.length == 5"
              [attr.aria-label]="comunText['agregar-revisor']">
              {{ comunText['agregar-revisor'] }}
            </button>
          </div>
          <app-table
            [columnas]="columnasRevisor"
            [datos]="datosRevisores"
            [acciones]="accionesRevisor"
            (eventoAccion)="eliminarRevisor($event)">
          </app-table>
          <!-- Apoderado -->
          <app-form
            #FormComponent
            *ngIf="mostrarTipoApoderado"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_apoderado']"
            [fields]="campoTipoApoderado"
            (changedControl)="capturarFormTipoApoderado($event)"
            [withSubmitButton]="false">
          </app-form>
          <!-- Apoderado PN -->
          <app-form
            #FormComponent
            *ngIf="mostrarApoderadoPN"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado_PN']"
            [fields]="camposApoderadoPN"
            (changedControl)="capturarFormApoderadoPN($event)"
            [withSubmitButton]="true"
            [sumbitButtonText]="comunText['agregar-apoderado']"
            (submitAction)="guardarProfesional(false, 'apoderado')"
            [filtrarTiposDocumento]="true">
          </app-form>
          <!-- Apoderado PJ -->
          <app-form
            #FormComponent
            *ngIf="mostrarApoderadoPJ"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado_PJ']"
            [fields]="camposApoderadoPJ"
            (changedControl)="capturarFormApoderadoPJ($event)"
            [withSubmitButton]="true"
            [sumbitButtonText]="comunText['agregar-apoderado']"
            (submitAction)="guardarProfesional(false, 'apoderado')">
          </app-form>
          <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
            {{ roiText['reorganizacion-ordinaria-insolvencia']['comun']['apoderado'] }}
          </h4>
          <div class="col-12 d-flex justify-content-end">
            <button
              type="submit"
              class="btn-govco fill-add-govco mt-3"
              (click)="habilitarTipoApoderado()"
              [disabled]="datosApoderados.length == 5"
              [attr.aria-label]="comunText['agregar-apoderado']">
              {{ comunText['agregar-apoderado'] }}
            </button>
          </div>
          <app-table
            [columnas]="columnasApoderado"
            [datos]="datosApoderados"
            [acciones]="accionesApoderado"
            (eventoAccion)="eliminarApoderado($event)">
          </app-table>
          <!-- Contador -->
          <app-form
            #FormComponent
            *ngIf="mostrarTipoContador"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['tipo_contador']"
            [fields]="campoTipoContador"
            (changedControl)="capturarFormTipoContador($event)"
            [withSubmitButton]="false">
          </app-form>
          <!-- Contador PN -->
          <app-form
            #FormComponent
            *ngIf="mostrarContadorPN"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador_PN']"
            [fields]="camposContadorPN"
            (changedControl)="capturarFormContadorPN($event)"
            [withSubmitButton]="true"
            [sumbitButtonText]="comunText['agregar-contador']"
            (submitAction)="guardarProfesional(false, 'contador')"
            [filtrarTiposDocumento]="true">
          </app-form>
          <!-- Contador PJ -->
          <app-form
            #FormComponent
            *ngIf="mostrarContadorPJ"
            [title]="roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador_PJ']"
            [fields]="camposContadorPJ"
            (changedControl)="capturarFormContadorPJ($event)"
            [withSubmitButton]="true"
            [sumbitButtonText]="comunText['agregar-contador']"
            (submitAction)="guardarProfesional(false, 'contador')">
          </app-form>
          <h4 class="wrapper__form__title h3-tipografia-govco mb-0">
            {{ roiText['reorganizacion-ordinaria-insolvencia']['comun']['contador'] }}
          </h4>
          <div class="col-12 d-flex justify-content-end">
            <button
              type="submit"
              class="btn-govco fill-add-govco mt-3"
              (click)="habilitarTipoContador()"
              [disabled]="datosContadores.length == 5"
              [attr.aria-label]="comunText['agregar-contador']">
              {{ comunText['agregar-contador'] }}
            </button>
          </div>
          <app-table
            [columnas]="columnasContador"
            [datos]="datosContadores"
            [acciones]="accionesContador"
            (eventoAccion)="eliminarContador($event)">
          </app-table>
          <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
              <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                      onclick="nextItemAdvanceLineIHorizonalBack(event)"
                      [attr.aria-label]="roiText['botones-envio']['atras']">
                {{ roiText['botones-envio']['atras'] }}
              </button>
              <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                      [disabled]="esFormularioInvalido"
                      (click)="guardarProceso(false)"
                      [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                {{ roiText['botones-envio']['guardar-sin-enviar'] }}
              </button>
              <button type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinueRevisoresContadores($event)"
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                {{ roiText['botones-envio']['continuar'] }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
      <div id="itemlineaAvance3" class="body-linea-avance-govco"
           data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección: Información de profesionales asociados al deudor-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][2]"
              [fields]="camposInfoProfesionales"
              [withSubmitButton]="false"
              (changedControl)="capturarFormProfesionales($event)">
            </app-form>
            <div *ngIf="mostrarArchivoApoderado">
              <!-- Archivo: Poder al abogado para realizar la solicitud-->
              <app-cargue-archivos-tramite
                *ngIf="validarAnexosPrecargados(1).length == 0"
                [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
                [paso]="1"
                [codigoPretencion]="'PNNC'"
                [idTramite]="idProceso"
                (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
                (archivosCargados)="validarArchivosCargados($event, 1)"
                [enviar]="enviarArchivos"
                [archivosPreCargados]="validarAnexosPrecargados(1)"
                [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
                (guardo)="subirArchivo($event)">
              </app-cargue-archivos-tramite>
              <app-cargue-archivos-tramite
                *ngIf="validarAnexosPrecargados(1).length > 0"
                [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
                [paso]="1"
                [codigoPretencion]="'PNNC'"
                [idTramite]="idProceso"
                (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
                (archivosCargados)="validarArchivosCargados($event, 1)"
                [enviar]="enviarArchivos"
                [archivosPreCargados]="validarAnexosPrecargados(1)"
                [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
                (guardo)="subirArchivo($event)">
              </app-cargue-archivos-tramite>
            </div>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                        onclick="nextItemAdvanceLineIHorizonalBack(event)"
                        [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                        (click)="guardarProceso(false)"
                        [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                  (click)="onContinue(formInfoProfesionales, 1, $event)"
                  [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance4" class="body-linea-avance-govco"
           data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección: Supuestos de admisibilidad-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][3]"
              [fields]="camposSupuestos"
              [withSubmitButton]="false"
              (changedControl)="capturarFormSupuestos($event)">
            </app-form>
            <!-- Archivos: Certificación que acredite la cesación de pagos y Anexo de la certificación de cesación de pagos-->
            <app-cargue-archivos-tramite
              *ngIf="validarAnexosPrecargados(3).length == 0"
              [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
              [paso]="3"
              [codigoPretencion]="'PNNC'"
              [idTramite]="idProceso"
              (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
              (archivosCargados)="validarArchivosCargados($event, 3)"
              [enviar]="enviarArchivos"
              [archivosPreCargados]="validarAnexosPrecargados(3)"
              [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
              (guardo)="subirArchivo($event)">
            </app-cargue-archivos-tramite>
            <app-cargue-archivos-tramite
              *ngIf="validarAnexosPrecargados(3).length > 0"
              [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
              [paso]="3"
              [codigoPretencion]="'PNNC'"
              [idTramite]="idProceso"
              (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
              (archivosCargados)="validarArchivosCargados($event, 3)"
              [enviar]="enviarArchivos"
              [archivosPreCargados]="validarAnexosPrecargados(3)"
              [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
              (guardo)="subirArchivo($event)">
            </app-cargue-archivos-tramite>
            <!-- Sección: Causas de la cesación pagos-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][15]"
              [fields]="camposCesacionPagos"
              [withSubmitButton]="false">
            </app-form>
            <!-- Archivo: Memoria explicativa de las causas de insolvencia-->
            <app-cargue-archivos-tramite
              *ngIf="validarAnexosPrecargados(2).length == 0"
              [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
              [paso]="2"
              [codigoPretencion]="'PNNC'"
              [idTramite]="idProceso"
              (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
              (archivosCargados)="validarArchivosCargados($event, 2)"
              [enviar]="enviarArchivos"
              [archivosPreCargados]="validarAnexosPrecargados(2)"
              [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
              (guardo)="subirArchivo($event)">
            </app-cargue-archivos-tramite>
            <app-cargue-archivos-tramite
              *ngIf="validarAnexosPrecargados(2).length > 0"
              [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
              [paso]="2"
              [codigoPretencion]="'PNNC'"
              [idTramite]="idProceso"
              (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
              (archivosCargados)="validarArchivosCargados($event, 2)"
              [enviar]="enviarArchivos"
              [archivosPreCargados]="validarAnexosPrecargados(2)"
              [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
              (guardo)="subirArchivo($event)">
            </app-cargue-archivos-tramite>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                        onclick="nextItemAdvanceLineIHorizonalBack(event)"
                        [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                        (click)="guardarProceso(false)"
                        [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                      (click)="onContinuePasoTres($event)"
                      [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance5" class="body-linea-avance-govco"
           data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección: Condición de controlante-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][19]"
              [fields]="camposCondicion"
              [withSubmitButton]="false"
              (changedControl)="capturarFormCondicion($event)">
            </app-form>
            <!-- Archivos: Certificación en la que se indique que el deudor es controlante de la sociedad o hace parte de un grupo de empresas
                           Composición del capital de la sociedad controlada
                           Certificado de existencia y representación legal de la sociedad-->
            <app-cargue-archivos-tramite
              *ngIf="validarAnexosPrecargados(4).length == 0"
              [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
              [paso]="4"
              [codigoPretencion]="'PNNC'"
              [idTramite]="idProceso"
              (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
              (archivosCargados)="validarArchivosCargados($event, 4)"
              [enviar]="enviarArchivos"
              [archivosPreCargados]="validarAnexosPrecargados(4)"
              [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
              (guardo)="subirArchivo($event)">
            </app-cargue-archivos-tramite>
            <app-cargue-archivos-tramite
              *ngIf="validarAnexosPrecargados(4).length > 0"
              [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
              [paso]="4"
              [codigoPretencion]="'PNNC'"
              [idTramite]="idProceso"
              (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
              (archivosCargados)="validarArchivosCargados($event, 4)"
              [enviar]="enviarArchivos"
              [archivosPreCargados]="validarAnexosPrecargados(4)"
              [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
              (guardo)="subirArchivo($event)">
            </app-cargue-archivos-tramite>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                        onclick="nextItemAdvanceLineIHorizonalBack(event)"
                        [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                        (click)="guardarProceso(false)"
                        [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                    (click)="onContinue(formCondicion,4,$event)"
                    [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance6" class="body-linea-avance-govco"
           data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección: Relación de bienes y acreencias con corte al último día del mes anterior-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][20]"
              [fields]="camposRelacionBienes"
              [withSubmitButton]="false"
              (changedControl)="capturarFormRelacionBienes($event)">
            </app-form>
            <!-- Archivos: Relación completa y detallada de los bienes y Relación completa y detallada de las acreencias -->
            <app-cargue-archivos-tramite
              *ngIf="validarAnexosPrecargados(5).length == 0"
              [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
              [paso]="5"
              [codigoPretencion]="'PNNC'"
              [idTramite]="idProceso"
              (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
              (archivosCargados)="validarArchivosCargados($event, 5)"
              [enviar]="enviarArchivos"
              [archivosPreCargados]="validarAnexosPrecargados(5)"
              [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
              (guardo)="subirArchivo($event)"
              [enviarEntidad]="enviarEntidad"
              [nombreCortoTramite]="nombreTramite">
            </app-cargue-archivos-tramite>
            <app-cargue-archivos-tramite
              *ngIf="validarAnexosPrecargados(5).length > 0"
              [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
              [paso]="5"
              [codigoPretencion]="'PNNC'"
              [idTramite]="idProceso"
              (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
              (archivosCargados)="validarArchivosCargados($event, 5)"
              [enviar]="enviarArchivos"
              [archivosPreCargados]="validarAnexosPrecargados(5)"
              [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
              (guardo)="subirArchivo($event)"
              [enviarEntidad]="enviarEntidad"
              [nombreCortoTramite]="nombreTramite">
            </app-cargue-archivos-tramite>
            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                        onclick="nextItemAdvanceLineIHorizonalBack(event)"
                        [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                        (click)="guardarProceso(false)"
                        [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-next-btn-govco btn-form w-auto"
                    (click)="onContinue(formRelacionBienes,5,$event)"
                    [attr.aria-label]="roiText['botones-envio']['continuar']">
                  {{ roiText['botones-envio']['continuar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="itemlineaAvance7" class="body-linea-avance-govco"
           data-la-parent="#lineaAvance3">
        <div class="contents-linea-avance-govco">
          <div class="contents-example-linea-avance-govco">
            <!-- Sección: Documentos adicionales-->
            <app-form
              [title]="roiText['reorganizacion-ordinaria-insolvencia']['subtitulos'][14]"
              [fields]="camposDocumentosAdicionales"
              [withSubmitButton]="false"
              (changedControl)="capturarFormDocumentosAdicionales($event)">
            </app-form>
            <!-- Archivo: archivo -->
            <div class="mt-3">
              <div class="card">
                <div class="card-header">
                  <h5 class="card-title">
                    {{ roiText['reorganizacion-ordinaria-insolvencia']['agregar-anexos'] }}
                  </h5>
                </div>
                <div class="card-body form-group">
                  <app-cargue-archivos-tramite
                    *ngIf="validarAnexosPrecargados(9).length == 0"
                    [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
                    [paso]="9"
                    [codigoPretencion]="'PNC'"
                    [idTramite]="idProceso"
                    (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
                    (archivosCargados)="validarArchivosCargados($event, 9)"
                    [enviar]="enviarArchivos"
                    [archivosPreCargados]="validarAnexosPrecargados(9)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
                    (guardo)="subirArchivo($event)">
                  </app-cargue-archivos-tramite>
                  <app-cargue-archivos-tramite
                    *ngIf="validarAnexosPrecargados(9).length > 0"
                    [idTipoTramite]="Constants.ID_ENTIDAD_SSO_LJI"
                    [paso]="9"
                    [codigoPretencion]="'PNC'"
                    [idTramite]="idProceso"
                    (archivosObligatoriosPasos)="validarArchivosRequeridos($event)"
                    (archivosCargados)="validarArchivosCargados($event, 9)"
                    [enviar]="enviarArchivos"
                    [archivosPreCargados]="validarAnexosPrecargados(9)"
                    [cantidadMaxAchivos]="Constants.CANTIDAD_ARCHIVOS_INSOLVENCIA"
                    (guardo)="subirArchivo($event)">
                  </app-cargue-archivos-tramite>
                </div>
              </div>
            </div>

            <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
              <div class="d-flex flex-column flex-md-row gap-2">
                <button type="button" class="btn-govco fill-before-btn-govco w-auto"
                        onclick="nextItemAdvanceLineIHorizonalBack(event)"
                        [attr.aria-label]="roiText['botones-envio']['atras']">
                  {{ roiText['botones-envio']['atras'] }}
                </button>
                <button type="button" class="btn-govco fill-btn-govco w-auto btn-form"
                        (click)="guardarProceso(false)"
                        [attr.aria-label]="roiText['botones-envio']['guardar-sin-enviar']">
                  {{ roiText['botones-envio']['guardar-sin-enviar'] }}
                </button>
                <button type="button" class="btn-govco fill-send-govco w-auto btn-form"
                    (click)="onContinueFinalizar($event)"
                    [attr.aria-label]="roiText['botones-envio']['finalizar-enviar']">
                  {{ roiText['botones-envio']['finalizar-enviar'] }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
